<template>
  <div>
    <bg :pcImg='pcBannerImg' :mobileImg='mobileBannerImg'>
      <scroll-nav :active-index='this.$route.name' :list='scrollNavList' cusValue='value' cusKey='title' @scrollNavClick='scrollNavClick'></scroll-nav>
    </bg>
    <!-- 走进广物的二级路由容器 -->
      <transition name="move" mode="out-in">
        <router-view></router-view>
      </transition>
  </div>
</template>
 
<script>
import {navList} from '../project.config'
import BG from '../components/common/BG'
import ScrollNav from '../components/common/ScrollNav'

export default {
  data() {
    return {
      pcBannerImg: require('../assets/img/two_banner_bg3.jpg'),
      mobileBannerImg: require('../assets/img/two_banner_mobile_bg3.jpg'),
      scrollNavList: navList[1].sub,
    }
  },
  components: {
    bg:BG,
    ScrollNav,
  },
  methods: {
    scrollNavClick(e) {
      this.$router.push(`/intothegroup/${e.value}`)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/css/register.scss';
@import '../assets/css/base.scss';

    /deep/ .el-image__inner--center {
      position:static\0\9;
      transform: none\0\9;
    }
</style>